/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The type of Zoom credential.

- `app`: SDK-only credentials (client_id and client_secret) for joining meetings
- `user`: User-authorized credentials with OAuth tokens for OBF token support
 */
export type ListZoomCredentials200DataItemCredentialType =
  (typeof ListZoomCredentials200DataItemCredentialType)[keyof typeof ListZoomCredentials200DataItemCredentialType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListZoomCredentials200DataItemCredentialType = {
  app: "app",
  user: "user"
} as const
